/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { findById3 } from '../fn/laboratory-reports/find-by-id-3';
import { FindById3$Params } from '../fn/laboratory-reports/find-by-id-3';
import { findLaboratoryReports } from '../fn/laboratory-reports/find-laboratory-reports';
import { FindLaboratoryReports$Params } from '../fn/laboratory-reports/find-laboratory-reports';
import { LaboratoryReport } from '../models/laboratory-report';
import { LaboratoryReportDetails } from '../models/laboratory-report-details';

@Injectable({ providedIn: 'root' })
export class LaboratoryReportsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findLaboratoryReports()` */
  static readonly FindLaboratoryReportsPath = '/api/lab-reports';

  /**
   * Gets the list of laboratory reports of an animal.
   *
   * # Permissions
   * - MANAGE_MEDICAL_HISTORY
   * - VIEW_MEDICAL_HISTORY
   * # Flow
   * - Returns all laboratory reports of the given animal
   * - If the animal doesn't exist or it is not related with tenant and instance of the user, returns empty results.
   * - If the user doesnt have permissions, the answer will be **UNAUTHORIZED** (401)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findLaboratoryReports()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLaboratoryReports$Response(params: FindLaboratoryReports$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LaboratoryReport>>> {
    return findLaboratoryReports(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the list of laboratory reports of an animal.
   *
   * # Permissions
   * - MANAGE_MEDICAL_HISTORY
   * - VIEW_MEDICAL_HISTORY
   * # Flow
   * - Returns all laboratory reports of the given animal
   * - If the animal doesn't exist or it is not related with tenant and instance of the user, returns empty results.
   * - If the user doesnt have permissions, the answer will be **UNAUTHORIZED** (401)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findLaboratoryReports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findLaboratoryReports(params: FindLaboratoryReports$Params, context?: HttpContext): Observable<Array<LaboratoryReport>> {
    return this.findLaboratoryReports$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LaboratoryReport>>): Array<LaboratoryReport> => r.body)
    );
  }

  /** Path part for operation `findById3()` */
  static readonly FindById3Path = '/api/lab-reports/{id}';

  /**
   * Gets the the data of a specific laboratory report.
   *
   * # Permissions
   * - MANAGE_MEDICAL_HISTORY
   * - VIEW_MEDICAL_HISTORY
   * # Flow
   * - Returns all laboratory report details of the given laboratory report
   * - If the laboratory report doesn't exist or it is not related with tenant and instance of the user, returns empty results.
   * - Validates also if the animal and customer are not deleted. If so, returns empty results.
   * - If the user doesnt have permissions, the answer will be UNAUTHORIZED (401)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById3()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById3$Response(params: FindById3$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LaboratoryReportDetails>>> {
    return findById3(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the the data of a specific laboratory report.
   *
   * # Permissions
   * - MANAGE_MEDICAL_HISTORY
   * - VIEW_MEDICAL_HISTORY
   * # Flow
   * - Returns all laboratory report details of the given laboratory report
   * - If the laboratory report doesn't exist or it is not related with tenant and instance of the user, returns empty results.
   * - Validates also if the animal and customer are not deleted. If so, returns empty results.
   * - If the user doesnt have permissions, the answer will be UNAUTHORIZED (401)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findById3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById3(params: FindById3$Params, context?: HttpContext): Observable<Array<LaboratoryReportDetails>> {
    return this.findById3$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LaboratoryReportDetails>>): Array<LaboratoryReportDetails> => r.body)
    );
  }

}
